import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import BalanceComp  from "./Component/BalanceComp"

const Balance =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <BalanceComp />
        </div>
        <Footer />
        </>
    )
}

export default Balance